<template>
    <div class="news-container">
        <div style="color: #f8f9fa; font-size: 1px;">1</div>
        <div class="content-wrapper">
            <SimpleHeader title="新聞動態" subtitle="讓我們一起看看最近的精彩瞬間！" />

            <div class="row g-4" style="margin-bottom: 6em;">
                <div class="col-12 col-md-6 col-lg-4" v-for="news in newsList" :key="news.id">
                    <div class="news-card">
                        <div class="card-image">
                            <img :src="`/api/file/download/${news.image}`" alt="新聞圖片"
                                class="image-content" />
                            <div class="image-overlay"></div>
                        </div>
                        <div class="card-content">
                            <div class="meta-info">
                                <span class="date">{{ news.date }}</span>
                                <span class="category">企業新聞</span>
                            </div>
                            <h3 class="title">{{ news.title }}</h3>
                            <p class="description">{{ news.description }}</p>
                            <a :href="`${news.link}?type=0&id=${encodeURIComponent(JSON.stringify(news.id))}`" class="action-button">
                                閱讀全文
                                <i class="bi bi-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            newsList: [
                // {
                //     id: 1,
                //     title: '新產品發佈：智能項目管理工具',
                //     date: '2023-10-01',
                //     description: '我們很高興地宣佈推出我們的新產品——智能項目管理工具，旨在提升團隊協作效率。',
                //     link: '#'
                // },
                // {
                //     id: 2,
                //     title: '成功案例：幫助客戶提升網站性能',
                //     date: '2023-09-15',
                //     description: '通過我們的優化方案，某客戶的網站加載速度提升了50%，客戶反饋非常滿意。',
                //     link: '#'
                // },
                // {
                //     id: 3,
                //     title: '技術分享：如何使用AI提升開發效率',
                //     date: '2023-08-30',
                //     description: '在本次技術分享中，我們探討了如何利用AI工具來加速開發流程和提高代碼質量。',
                //     link: '#'
                // },
                // {
                //     id: 4,
                //     title: '團隊擴展：歡迎新成員加入',
                //     date: '2023-09-20',
                //     description: '我們很高興地歡迎幾位新成員加入我們的開發團隊，期待他們帶來的新思路。',
                //     link: '#'
                // },
                // {
                //     id: 5,
                //     title: '行業動態：2023年軟件開發趨勢分析',
                //     date: '2023-09-05',
                //     description: '我們對2023年軟件開發的最新趨勢進行了深入分析，分享了我們的見解和預測。',
                //     link: '#'
                // },
                // {
                //     id: 6,
                //     title: '客戶反饋：提升用戶體驗的成功案例',
                //     date: '2023-10-10',
                //     description: '通過我們的用戶體驗設計，客戶的產品滿意度提升了30%，獲得了良好的市場反饋。',
                //     link: '#'
                // }
            ]
        };
    },
    mounted() {
        this.GetMenuList()
    },

    methods: {
        //获取新闻动态的列表
        GetMenuList() {
            this.$axios.get(`/news/list?page=1&perPage=100000`)
                .then(res => {
                    for (let index = res.data.data.items.length - 1; index >= 0; index--) {
                        var data = {
                            id: res.data.data.items[index].id,
                            title: res.data.data.items[index].title,
                            date: this.formatDate(res.data.data.items[index].create_at * 1000),
                            description: res.data.data.items[index].introduce,
                            news_type: res.data.data.items[index].news_type,
                            image: res.data.data.items[index].image,
                            content: res.data.data.items[index].content,
                            read_count: res.data.data.items[index].read_count,
                            link: '/article'
                        };
                        this.newsList.push(data);
                    }
                    console.log("66666")

                    console.log(this.newsList)
                })
                .catch(e => {
                    console.log(e)
                })
        },

        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }
};
</script>

<style scoped>
.news-container {
    background: #f8f9fa;
    /* padding: 4rem 0; */
}

.content-wrapper {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1.5rem;
}

.news-card {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    height: 100%;
    display: flex;
    flex-direction: column;
}

.news-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 115, 255, 0.15);
}

.card-image {
    position: relative;
    height: 240px;
    overflow: hidden;
}

.image-content {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.news-card:hover .image-content {
    transform: scale(1.1);
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.6) 100%);
}

.card-content {
    padding: 1.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.meta-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    font-size: 0.9rem;
}

.date {
    color: #6c757d;
}

.category {
    color: #0073ff;
    font-weight: 500;
    padding: 4px 8px;
    background: rgba(0, 115, 255, 0.1);
    border-radius: 4px;
}

.title {
    color: #212529;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 1rem;
    min-height: 3.5em;
}

.description {
    color: #495057;
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.action-button {
    display: inline-flex;
    align-items: center;
    color: #0073ff;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    margin-top: auto;
}

.action-button i {
    margin-left: 8px;
    transition: transform 0.3s ease;
}

.action-button:hover {
    color: #0056b3;
}

.action-button:hover i {
    transform: translateX(4px);
}

@media (max-width: 768px) {
    .news-container {
        padding: 2rem 0;
    }

    .card-image {
        height: 200px;
    }

    .title {
        font-size: 1.2rem;
    }
}
</style>